/**
 * @fileoverview The instrument suggestion list, shared by the roster, profile
 * and onboarding pickers.
 *
 * ONE list, mirrored byte-for-byte (quote style aside) in
 * `mobile/src/lib/instruments.js`, and a backend test
 * (`test_instrument_catalogue.py`) holds the two together. The clients used to
 * carry different lists: web offered "Keyboards" and "DJ / Turntablism" where
 * the phone offered "Keyboard" and "DJ", so a student tagged on one device did
 * not match the same student tagged on the other. An instrument is stored as
 * the free text the picker inserted, so the label IS the identity.
 *
 * Flat and alphabetical: both pickers filter by prefix and show the matches in
 * list order, so family grouping had no effect on what anyone saw. Synonyms
 * ("Double Bass" / "Upright Bass") stay because both are already stored.
 */

export const INSTRUMENTS = [
  "Accordion",
  "Acoustic Guitar",
  "Alto Saxophone",
  "Bagpipes",
  "Balalaika",
  "Bandoneón",
  "Banjo",
  "Baritone Horn",
  "Baritone Saxophone",
  "Bass Clarinet",
  "Bass Guitar",
  "Bassoon",
  "Beatboxing",
  "Bongos",
  "Bouzouki",
  "Bugle",
  "Cajon",
  "Celesta",
  "Cello",
  "Charango",
  "Clarinet",
  "Classical Guitar",
  "Clavichord",
  "Composition",
  "Concertina",
  "Conducting",
  "Congas",
  "Contrabassoon",
  "Cornet",
  "Didgeridoo",
  "DJ",
  "Djembe",
  "Dobro",
  "Double Bass",
  "Drum Kit",
  "Drums",
  "Dulcimer",
  "Electric Guitar",
  "Electronic Drums",
  "English Horn",
  "Erhu",
  "Euphonium",
  "Fiddle",
  "Fife",
  "Flugelhorn",
  "Flute",
  "French Horn",
  "Glockenspiel",
  "Guitar",
  "Guzheng",
  "Hammered Dulcimer",
  "Hang Drum",
  "Harmonica",
  "Harp",
  "Harpsichord",
  "Kalimba",
  "Keyboard",
  "Koto",
  "Lap Steel Guitar",
  "Lute",
  "Lyre",
  "Mandolin",
  "Marimba",
  "Mbira",
  "Melodica",
  "Music Production",
  "Music Theory",
  "Oboe",
  "Ocarina",
  "Organ",
  "Oud",
  "Pan Flute",
  "Pedal Steel Guitar",
  "Percussion",
  "Piano",
  "Piccolo",
  "Pipa",
  "Recorder",
  "Saxophone",
  "Shakuhachi",
  "Shamisen",
  "Sight-Reading",
  "Sitar",
  "Snare Drum",
  "Songwriting",
  "Soprano Saxophone",
  "Sousaphone",
  "Steel Drums",
  "Synthesizer",
  "Tabla",
  "Tambourine",
  "Tenor Saxophone",
  "Theremin",
  "Timpani",
  "Tin Whistle",
  "Trombone",
  "Trumpet",
  "Tuba",
  "Ukulele",
  "Upright Bass",
  "Vibraphone",
  "Viola",
  "Violin",
  "Voice",
  "Xylophone",
  "Zither",
];
